<div class="container pb-4 pt-4 pe-0 pe-md-2 ps-0 ps-md-2">
  <app-breadcrumb currentRouteName="Politique de confidentialité"></app-breadcrumb>
  <h1 class="pt-3 pb-2 ps-2 ps-md-0">Politique de confidentialité</h1>

  <div class="block p-2 p-md-4">
    <div class="">
      <p>
        La création de votre compte utilisateur sur le Portail client Libriciel demande la
        saisie de données personnelles vous concernant. Vous trouverez ci-dessous le
        détail des informations collectées ainsi que les traitements effectués. Ces
        données sont collectées uniquement dans le cadre de votre activité
        professionnelle et pour l'utilisation exclusive du Portail client Libriciel.

        <br><br>

        Le fonctionnement dans les conditions nominales et recommandées de
        l'application, ne permet pas de partager ou de diffuser à un tiers vos
        informations personnelles. Vous pouvez demander à tout moment à l'administrateur
        de la plateforme de vous communiquer l'ensemble des informations collectées pour
        la création de votre compte.
      </p>

      <h2>
        Article 1 - Mentions légales
      </h2>

      <h3 class="pt-2">
        1.1 Logiciel (ci-après « le logiciel ») :
      </h3>
      <p>Portail client Libriciel</p>

      <h3 class="pt-2">
        1.2 Éditeur (ci-après « l'éditeur ») :
      </h3>

      <p style="white-space: pre-wrap;">
        LIBRICIEL SCOP<br>
        140, rue Aglaonice de Thessalie, 34170 Castelnau-le-lez<br>
        numéro SIRET : 491 011 698 00025<br>
      </p>

      <h2>
        Article 2 - Hébergement
      </h2>

      <h3 class="pt-2">
        2.1 Hébergeur (ci-après « l'hébergeur ») :
      </h3>

      <p style="white-space: pre-wrap;">Vos données sont hébergées chez plusieurs de nos sous-traitants, uniquement sur
        le territoire Français.<br>
        Le Portail client est hébergé par :<br>
        Libriciel SCOP<br>
        140, rue Aglaonice de Thessalie, 34170 Castelnau-le-lez<br>
        représentée par : M. Frédéric LOSSERAND, en sa qualité de :<br>
        Président-directeur Général<br>
        numéro SIRET : 491 011 698 00025<br>
        code APE : 6202B<br>
        n° de téléphone : 04.67.65.96.44<br>
        e-mail : contact&#64;libriciel.coop<br>
      </p>

      <h3 class="pt-2">
        2.2 Délégué à la protection des données (DPO) :
      </h3>

      <p style="white-space: pre-wrap;">
        Vous pouvez contacter notre Délégué à la Protection des Données à l'adresse mail suivante :
        <a href="mailto:dpo@libriciel.fr" class="ng-binding">dpo&#64;libriciel.fr</a>
      </p>

      <h2>
        Article 3 - Collecte
      </h2>

      <p>
        <strong>Création d'un utilisateur</strong> : Lors de la création de votre compte utilisateur, les informations
        suivantes sont collectées obligatoirement :
      </p>
      <ul>
        <li>Nom de l'utilisateur</li>
        <li>Prénom de l'utilisateur</li>
        <li>Adresse de messagerie professionnelle</li>
        <li>N° de téléphone professionnel</li>
        <li>Identifiant de connexion</li>
        <li>Fonction au sein de sa structure</li>
      </ul>


      <h2>
        Article 4 - Traitements
      </h2>

      <p>Vos informations personnelles sont utilisées pour le bon fonctionnement du Portail client dans les cas listés
        ci-après :</p>

      <ul>
        <li>Liste des utilisateurs : votre nom, prénom et votre courriel apparaissent dans la liste</li>
        <li>Notification par mail en cas de mise à jour des tickets d'assistance</li>
      </ul>

      <h2>
        Article 5 - Droit à l'oubli
      </h2>

      <p>
        Sur votre demande ou à la demande d'un utilisateur référent Portail, votre compte utilisateur peut être supprimé
        définitivement.
      </p>

      <p>
        La suppression de votre compte laissera les traces de votre activité :
      </p>
      <ul>
        <li>Sur les tickets d'assistance créés. Ces traces disparaîtront à la suppression définitive des tickets en
          question
        </li>
      </ul>

      <h2>
        Article 6 - Vos droits sur les données vous concernant
      </h2>

      <p>
        Vous pouvez accéder et obtenir une copie des données vous concernant, vous opposer au traitement de ces données,
        les faire rectifier ou les faire effacer. Vous disposez également d'un droit à la limitation du traitement de
        vos données.
      </p>
      <a href="https://www.cnil.fr/fr/les-droits-pour-maitriser-vos-donnees-personnelles"
         rel="nofollow noreferrer noopener" target="_blank">&gt; Comprendre vos droits informatique et libertés</a>

      <h3 class="pt-2">
        Exercer ses droits
      </h3>
      <p>
        Pour exercer vos droits sur les données personnelles vous concernant, vous pouvez contacter le Délégué à la
        Protection des Données (DPO), à l’adresse suivante :
      </p>
      <ul>
        <li><a href="mailto:dpo@libriciel.fr" class="ng-binding">dpo&#64;libriciel.fr</a></li>
      </ul>

      <h3 class="pt-2">
        Réclamation (plainte) auprès de la CNIL
      </h3>

      <p>Si vous estimez, après nous avoir contacté, que vos droits sur vos données ne sont pas respectés, vous pouvez
        <a href="https://www.cnil.fr/fr/plaintes" rel="nofollow noreferrer noopener" target="_blank">adresser une
          réclamation (plainte) à la CNIL</a></p>
    </div>
  </div>
</div>
